var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ma-modal",
    {
      ref: "modalMultidamagePhotoclaimForm",
      staticClass: "modal-photoclaim-form",
      attrs: { type: "full" },
      on: { "modal:close": _vm.hideModal },
    },
    [
      !_vm.loading
        ? _c("template", { slot: "modalContent" }, [
            _c(
              "div",
              { staticClass: "modal__main view" },
              [
                _c("ma-notifications"),
                _c("div", { staticClass: "view_content" }, [
                  _c("div", { staticClass: "view_content_markdown" }, [
                    _vm.damagedPart
                      ? _c("h2", [_vm._v(_vm._s(_vm.damagedPart.literal))])
                      : _vm._e(),
                  ]),
                  _c("div", { staticClass: "camera__damages" }, [
                    _c(
                      "div",
                      { staticClass: "damage__photos" },
                      _vm._l(_vm.damagedPhotos, function (photo) {
                        return _c("figure", { staticClass: "damage-img" }, [
                          _c("img", { attrs: { src: photo } }),
                        ])
                      }),
                      0
                    ),
                  ]),
                  _vm.damagesDetected
                    ? _c(
                        "div",
                        { staticClass: "damages-list" },
                        _vm._l(_vm.damagesDetected, function (damage, i) {
                          return _c(
                            "ul",
                            {
                              key: i,
                              ref: "damageItemPhotoclaim",
                              refInFor: true,
                            },
                            [
                              _c("maDamageItemPhotoclaim", {
                                attrs: { damage: damage, options: true },
                                on: {
                                  "option:edit": function ($event) {
                                    return _vm.$emit("option:edit", i)
                                  },
                                  "option:delete": function ($event) {
                                    return _vm.$emit("option:delete", i)
                                  },
                                },
                              }),
                            ],
                            1
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                  _c("div", { staticClass: "damages-add-button" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn",
                        on: {
                          click: function ($event) {
                            return _vm.$emit("form:partDamagePhotoclaimAdd")
                          },
                        },
                      },
                      [
                        _c("svgicon", {
                          attrs: {
                            name: "plus",
                            color: "#005BA5",
                            height: "15",
                            width: "auto",
                          },
                        }),
                        _c("p", { staticClass: "text-medium" }, [
                          _vm._v("Ajouter des dommages"),
                        ]),
                      ],
                      1
                    ),
                  ]),
                ]),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "view_actions" },
              [
                _c("maButton", {
                  attrs: {
                    handleButtonClick: _vm.handleConfirmBtn,
                    title: "Confirmez les dommages",
                    shouldBeDisabled:
                      _vm.damagesDetected && _vm.damagesDetected.length === 0,
                    btnType: "functionalBtn",
                  },
                }),
              ],
              1
            ),
          ])
        : _c("template", { slot: "modalContent" }, [
            _c(
              "div",
              { staticClass: "modal__main has-modal" },
              [_c("maSpinner", { staticClass: "spinner" })],
              1
            ),
          ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }